import { useCallback } from "react";
import {
  formatFullDateAndTimeWithLocalTimezoneV2,
  formatShortFormDate,
} from "~/utils/datetime";

export const useDateFormatterWithTimezone = () => {
  const formatDateWithTimezone = useCallback(
    (
      dateString: string | undefined,
      dateFormatOverride: string = "MMMM d, yyyy 'at' h:mm a",
      includeTzName: boolean = true,
    ) => {
      return typeof dateString === "string"
        ? formatFullDateAndTimeWithLocalTimezoneV2(
            dateString,
            dateFormatOverride,
            includeTzName,
          )
        : "--";
    },
    [],
  );
  return { formatDateWithTimezone };
};

export const useShortDateFormatter = () => {
  const shortDateFormatter = useCallback(
    (dateString: string | undefined, dateFormatOverride?: string) => {
      return typeof dateString === "string"
        ? formatShortFormDate(dateString, dateFormatOverride)
        : "--";
    },
    [],
  );
  return { shortDateFormatter };
};

export const getMinSelectableDate = (): Date => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(0, 0, 0, 0);
  return tomorrow;
};
